const FormRow = ({ type, name, value, handleChange, labelText, testId }) => {
  return (
    <div className='form-row'>
      <label htmlFor={name} className='form-label'>
        {labelText || name}
      </label>
      <input
        type={type}
        value={value}
        name={name}
        onChange={handleChange}
        className='form-input'
        data-testid={testId}
      />
    </div>
  )
}

export default FormRow
